import VolumeOffRoundedIcon from '@mui/icons-material/VolumeOffRounded';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import { CircularProgress, IconButton } from '@mui/material';
import { trackingStore } from '@stores/Tracking';
import { useUIPreferences } from '@stores/UIPreferences';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import css from './SoundToggle.module.scss';

export const SoundToggle = observer(function SoundToggle() {
  const uiPreferences = useUIPreferences();

  return (
    <div className={css.soundToggleContainer}>
      <IconButton
        className={classNames(css.soundToggle, {
          [css.loading]: uiPreferences.isLoading,
        })}
        onClick={() => {
          const newValue = !uiPreferences.soundEnabled;
          uiPreferences.setSoundEnabled(newValue);
          trackingStore.soundToggled({ enabled: newValue });
        }}
        disabled={uiPreferences.isLoading}
        aria-label={uiPreferences.soundEnabled ? 'Mute sound' : 'Unmute sound'}
      >
        {uiPreferences.soundEnabled ? <VolumeUpRoundedIcon /> : <VolumeOffRoundedIcon />}
      </IconButton>
      {uiPreferences.isLoading && (
        <div className={css.loadingOverlay}>
          <CircularProgress size={16} />
        </div>
      )}
    </div>
  );
});
